import { Box, NavLink, Select, Stack, Divider } from "@mantine/core";
import {
  CoursesIcon,
  DashboardIcon,
  DevelopmentPlanIcon,
  LogOutIcon,
  ProfileIcon,
  ReportIcon,
} from "../../../shared/svg";
import { useMediaQuery } from "@mantine/hooks";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./MainSidebar.scss";
import useAuthStore from "../../../store/useAuthStore";
import useReportStore from "../../../store/useReportStore";
import useCoursesStore from "../../../store/useCoursesStore";
import useDashboardStore from "../../../store/useDashboardStore";
import useProfileStore from "../../../store/useProfileStore";
import useDevelopmentStore from "../../../store/useDevelopmentStore";
import { setProfileLanguage } from "../../../api/profileApi";

export const MainSidebar = () => {
  const matches = useMediaQuery("(max-width: 670px)");
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const { resetReportState } = useReportStore();
  const { resetCoursesState } = useCoursesStore();
  const { resetDashboardState } = useDashboardStore();
  const { resetProfileState, getProfileLanguage } = useProfileStore();
  const { resetDevelopmentState } = useDevelopmentStore();
  const { access_token, refresh_token, logout } = useAuthStore();

  const handleLanguageChange = async (value: string | null) => {
    if (value) {
      i18n.changeLanguage(value);
      if (access_token) {
        await setProfileLanguage(value);
        await getProfileLanguage();
      }
    }
  };

  const handleLogout = async () => {
    if (!access_token || !refresh_token) return;

    await logout(access_token, refresh_token);
    // setChanges(false);
    resetCoursesState();
    resetReportState();
    resetDashboardState();
    resetProfileState();
    resetDevelopmentState();
  };

  return (
    <Box
      className="sidebar"
      w={240}
      bg="#fff"
      pos="relative"
      h={matches ? "100dvh" : "calc(100vh - 75px)"}
      pt={matches ? 64 : 32}
      pb="sm"
      style={{
        display: "flex",
        flexDirection: "column",
        overflowY: "auto", // 👈 Додаємо скрол
      }}
    >
      {/* Навігаційна частина */}
      <Box style={{ flex: 1 }}>
        <Stack gap={0}>
          <NavLink
            label={t("dashboard")}
            className="sidebar-link"
            leftSection={<DashboardIcon />}
            active={location.pathname === "/"}
            to="/"
            component={Link}
          />
          <NavLink
            label={t("profile")}
            className="sidebar-link"
            leftSection={<ProfileIcon />}
            active={location.pathname === "/profile"}
            to="/profile"
            component={Link}
          />
          <NavLink
            label={t("development_plan")}
            className="sidebar-link"
            leftSection={<DevelopmentPlanIcon />}
            active={location.pathname === "/development-plan"}
            to="/development-plan"
            component={Link}
          />
          <NavLink
            label={t("courses")}
            className="sidebar-link"
            leftSection={<CoursesIcon />}
            active={location.pathname === "/courses"}
            to="/courses"
            component={Link}
          />
          <NavLink
            label={t("report")}
            className="sidebar-link"
            leftSection={<ReportIcon />}
            active={location.pathname === "/report"}
            to="/report"
            component={Link}
          />
          {!matches && (
            <NavLink
              label={t("log_out")}
              className="sidebar-link"
              onClick={handleLogout}
              leftSection={<LogOutIcon />}
              to="/auth/sign-up"
              component={Link}
              color="red"
            />
          )}
        </Stack>
      </Box>

      {/* Нижній блок */}
      {matches && (
        <Box mt="auto">
          <Divider my="sm" />
          <Stack gap="xs">
            <Select
              value={i18n.language}
              onChange={handleLanguageChange}
              data={[
                { value: "en", label: t("english") },
                { value: "uk", label: t("ukrainian") },
              ]}
              size="sm"
              radius="md"
              mx="sm"
              style={{ width: "auto" }}
              comboboxProps={{ position: "top", zIndex: 1000 }}
            />
            <NavLink
              label={t("log_out")}
              className="sidebar-link"
              onClick={handleLogout}
              leftSection={<LogOutIcon />}
              to="/auth/sign-up"
              component={Link}
              color="red"
            />
          </Stack>
        </Box>
      )}
    </Box>
  );
};
